import { SeoService } from './../seoService';
import { Component, ViewContainerRef, ViewEncapsulation, OnInit, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit{

  faviconUrl: string | undefined;


	public constructor(private viewContainerRef: ViewContainerRef, private seoService: SeoService ) {}

  ngOnInit() {
    const faviconUrl = this.seoService.getFaviconUrl();
    const link: HTMLLinkElement = document.querySelector('link[rel="icon"]') || document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = faviconUrl;
    document.head.appendChild(link);
  }

}



